import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { LiveMapDispatchService } from 'app/pages/A2-utils/live-map-dispatch/live-map-dispatch.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { GoogleMapsComponent } from '../../../A2-utils/google-maps/google-maps.component';

@Component({
  selector: 'app-autorouting-map',
  templateUrl: './autorouting-map.component.html',
  styleUrls: ['./autorouting-map.component.scss']
})
export class AutoroutingMapComponent implements  OnChanges, OnInit {

  @ViewChild(GoogleMapsComponent) map: GoogleMapsComponent;
  @Input() onLoadSchedule?: any[];
  @Input() driver?: any[];
  @Input() tripsUnassigned?: any[] = [];
  @Input() showUnassignedMap: boolean;
  @Input() onPointsSelected?: any[];

  mapIsLoad = false;
  private decodePolyline: any;

  pointUnassignedMap: any[] = []; // Puntos unassignedMap

  constructor(private loading: T2LoadingService,
              private liveMapDispatcherService: LiveMapDispatchService) { }

  onMapInitialized() {
    this.mapIsLoad = true;
  }


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['onLoadSchedule']) {
      this.map.clearPolylines();
      this.map.clearMarkers();
      if (this.onLoadSchedule.length > 0) {
        this.getDataLoadSch(this.onLoadSchedule);
        this.showTripsUnassigned(this.showUnassignedMap);
      }
    }

    if (changes['tripsUnassigned'] || changes['showUnassignedMap']) {
      this.showTripsUnassigned(this.showUnassignedMap);
    }

    if (changes['onPointsSelected']) {
      if (this.onPointsSelected.length > 0) {
        this.clearPinUnassigned();
        this.onCenterPints();
      } else {
        this.clearPinUnassigned();
        this.showTripsUnassigned(this.showUnassignedMap);
      }
    } else {
      if (this.mapIsLoad) {
        this.onCenterMap();
      }
    }
  }

  validateDrawingPolyline(geometry: string, driver: any) {
    if (geometry) {
      this.decodePolyline = this.map.decodePolyline(geometry);
      this.map.addPolylineDotsAutorouting(this.decodePolyline, driver.drivercolor);
    }
    this.loading.hiden();
  }

  getDataLoadSch(schedules: any): void {
    schedules.forEach((stops: any[]) => {
      const stopsMap = this.groupLocation(stops);
      const driver = this.getColor(stops[0].scheduleid);
      stopsMap.forEach( (stopMap: { header: any, detail: any, position: any }) => {
        if (stopMap.header !== undefined) {
          const header = stopMap.header;
          this.setPoint(header.latitude, header.longitude,
                        this.transformText(stopMap), driver.drivercolor.slice(1), stopMap.position);
        }
      });

      const stopMapService = stopsMap.map( f => { return { lat: f.header.latitude, lng: f.header.longitude }; });
      this.liveMapDispatcherService
        .getOsrmFullPath(stopMapService)
        .finally(() => this.loading.hiden())
        .subscribe((resp) => {
          this.validateDrawingPolyline(resp.routes[0].geometry, driver); // location
        });
    });

    if (this.map.markers.length > 0) {
      this.map.centerOverMarkers();
    }
  }

  groupLocation(stops: any): any {
    if (!stops || !stops.length) {
      return [];
    }

    const stopsMap: any[] = stops.reduce((acc: any[], stop: { latitude: any; longitude: any; }) => {
      const lastStopGroup = acc[acc.length - 1];
      if (
        lastStopGroup &&
        lastStopGroup.header.latitude === stop.latitude &&
        lastStopGroup.header.longitude === stop.longitude
      ) {
        lastStopGroup.detail.push(stop);
      } else {
        acc.push(this.pointConstructor(stop));
      }
      return acc;
    }, []);

    const locations = new Map<string, any[]>();

    stopsMap.forEach(stopMap => {
      const key = `${stopMap.header.latitude},${stopMap.header.longitude}`;
      if (!locations.has(key)) { locations.set(key, []); }
      locations.get(key).push(stopMap);
    });

    locations.forEach(stopsInSameLocation => {
      let positionOffset = 0;
      stopsInSameLocation.forEach(stopMap => {
        stopMap.position = positionOffset;
        positionOffset += 25;
      });
    });

    return stopsMap;
  }

  /**
   * Draw Maps to Drivers
   * @param schedule
   */
  loadSchedules(schedule) {

    schedule.forEach((row: any[]) => {
      const points = this.groupByLocations(row);

      points.forEach((sch, index, array) => {
        if (sch.header !== undefined) {

        const header = sch.header;
        const driver = this.getColor(header.scheduleid);

        this.setPoint(header.latitude, header.longitude,
          this.transformText(sch), driver.drivercolor.slice(1), sch.position);
        if (index <= (points.length - 2)) {
          if (array[index + 1].header.latitude) {
             const pickup = { lat: header.latitude, lng: header.longitude };
             const dropoff = { lat: array[index + 1].header.latitude, lng: array[index + 1].header.longitude };
             this.map.addPolylineDots2([pickup, dropoff], driver.drivercolor);
          }
          }
        }

      });
    });

    if (this.map.markers.length > 0) {
      this.map.centerOverMarkers();
    }
  }
  transformText(point) {
    const length = point.detail.length;
    // alert( length);
    if ( length > 1) {
      return ( `${point.detail[0].order} - ${point.detail[length - 1].order} `);
    } else {
      return `${point.detail[0].order}`;
    }
  }

  getColor(scheduleid: number) {
    return this.driver.filter((row) => {
      return row.scheduleid === scheduleid;
    })[0];
  }

  setPoint(lat, lng, text, color, position) {

    const point = { lat: lat, lng: lng };
    this.map.addMarker2(point, this.map.customIcon2(text, color, position), text);
    // this.map.centerOverMarkers();
  }

  showTripsUnassigned(show: boolean) {
    if (this.tripsUnassigned.length > 0 && show !== undefined) {
      this.clearPinUnassigned();
      this.tripsUnassigned.forEach((row: any) => {
        const pickup = {
          lat: row.triplocationpickup.latitude,
          lng: row.triplocationpickup.longitude
        };
        const dropoff = {
          lat: row.triplocationdropoff.latitude,
          lng: row.triplocationdropoff.longitude
        };

        if (show) {
          this.pointUnassignedMap.push(this.map.addMarker2(pickup, this.map.customIcon2('P', 'ff0000'), 'P - ' + row.consecutive));
          this.pointUnassignedMap.push(this.map.addMarker2(dropoff, this.map.customIcon2('D', 'ff0000'), 'D - ' + row.consecutive));
        } else {
          this.pointUnassignedMap.forEach(marker => {
            this.map.removeMarker(marker);
          });
        }
      });
    }
  }

  onCenterPints() {
    const bounds = [];
    this.onPointsSelected.forEach((row) => {
      const pickup = {
        lat: row.pickup.latitude,
        lng: row.pickup.longitude
      };
      const dropoff = {
        lat: row.dropoff.latitude,
        lng: row.dropoff.longitude
      };

      bounds.push(this.map.latLng(row.pickup.latitude, row.pickup.longitude));
      bounds.push(this.map.latLng(row.dropoff.latitude, row.dropoff.longitude));

      this.pointUnassignedMap.push(this.map.addMarker2(pickup, this.map.customIcon('P', 'ff0000'), 'P - ' + row.consecutive));
      this.pointUnassignedMap.push(this.map.addMarker2(dropoff, this.map.customIcon('D', 'ff0000'), 'D - ' + row.consecutive));
    });
    if (this.map.markers.length > 0) {
      this.map.centerOverMarkers();
    }
    // this.map.centerOverSomeMakers(bounds);
  }

  clearPinUnassigned() {
    this.pointUnassignedMap.forEach(marker => {
      this.map.removeMarker(marker);
    });
  }

  /**
   * Agrupará puntos que comparten el mismo location y se presentan consecutivamente.
   */
  groupByLocations(points) {
    const puntosMap: any[] = [];
    points.forEach((row, index) => {
      const length = puntosMap.length;
      if ( length === 0) {
        puntosMap.push(this.pointConstructor(row));
      } else {
        if (row.latitude === points[index - 1].latitude && row.longitude === points[index - 1].longitude) {
          puntosMap[length - 1].detail.push(row);
        }else {
          puntosMap.push(this.pointConstructor(row));
        }
      }
    });
    puntosMap.forEach((item, index) => {
      if (item.position === undefined) {
        item.position = 0;
      puntosMap.forEach((item2, index2) => {
        let counter = 0;
        if ( index !== index2 && item2.position === undefined) {
          if (item2.header.latitude === item.header.latitude && item2.header.longitude === item.header.longitude) {
            counter = counter + 25;
            item2.position =  counter;
          }
        }
      });
      }
    });
    return puntosMap;
  };

  /**
   * Crea el Punto y el detalle.
   * @param row
   */
  pointConstructor(row) {
    return {
      header: row,
      detail: [row]
    };
  }

  onCenterMap() {
    if (this.showUnassignedMap && this.onLoadSchedule.length > 0) {
      this.map.centerOverMarkers();
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/components/autorouting-map/autorouting-map.component.ts